export default __webpack_public_path__ + "static/export.a434ca2ae6e9eecce0006553b5d2dada.svg";